import axios from 'axios';
import appConfig from '../config';

const apiClient = axios.create({
  baseURL: appConfig.baseURL,
  timeout: appConfig.apiTimeout,
});

// Add a request interceptor to automatically attach the token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle authorization errors globally (e.g. account suspension or expired token)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url && (error.config.url.includes('/admin/login') || error.config.url.includes('/login'));
    if (!isLoginRequest && error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.log("Session expired or account suspended. Logging out...");
      const role = (localStorage.getItem("role") || "").toLowerCase();
      localStorage.clear();
      if (role === "affiliate") {
        window.location.href = "/login/affiliate";
      } else if (role === "subadmin" || role === "manager") {
        window.location.href = "/login/manager";
      } else {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
